import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TariffComponentMaintenanceCont from "presentation/view/container/TariffComponent/TariffComponentContMain";

CommonEntrypoint(<TariffComponentMaintenanceCont/>)